var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBubbleTea(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M50.74,2.93H40.45c-0.391,0-0.75,0.23-0.91,0.58l-2.6,5.75H16.99c-0.55,0-1,0.45-1,1v4.69h-2.73c-0.55,0-1,0.45-1,1v5.21   c0,0.55,0.45,1,1,1h2.16v26.55c0,6.82,5.55,12.36,12.37,12.36h5.05c6.82,0,12.37-5.54,12.37-12.36V22.16h2.16c0.55,0,1-0.45,1-1   v-5.21c0-0.55-0.45-1-1-1h-2.73v-4.69c0-0.55-0.449-1-1-1H42.16l0.67-1.49h7.91c0.55,0,1-0.45,1-1V3.93   C51.74,3.37,51.29,2.93,50.74,2.93z M43.21,22.16v26.55c0,5.71-4.65,10.36-10.37,10.36h-5.05c-5.72,0-10.37-4.65-10.37-10.36V22.16   h13.67L19.85,46.91c-0.16,0.36-0.1,0.78,0.16,1.07c0.2,0.22,0.47,0.34,0.76,0.34c0.09,0,0.19-0.01,0.29-0.04l3.23-0.99   c0.27-0.08,0.5-0.28,0.62-0.53l11.46-24.6H43.21z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 27.75,
    r: 2.81
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.23,35c0,1.55-1.261,2.81-2.811,2.81S31.6,36.55,31.6,35s1.27-2.81,2.82-2.81S37.23,33.45,37.23,35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.48,44.17c0,1.55-1.261,2.81-2.811,2.81s-2.82-1.26-2.82-2.81c0-1.55,1.271-2.82,2.82-2.82S40.48,42.62,40.48,44.17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.23,48.92c0,1.55-1.26,2.81-2.811,2.81c-1.55,0-2.82-1.26-2.82-2.81c0-1.55,1.27-2.82,2.82-2.82   C31.97,46.1,33.23,47.37,33.23,48.92z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.75,
    cy: 53.5,
    r: 2.81
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.81,54.67c0,1.55-1.26,2.81-2.81,2.81s-2.81-1.26-2.81-2.81c0-1.55,1.26-2.82,2.81-2.82S38.81,53.12,38.81,54.67z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.98,28.42c0,1.55-1.26,2.81-2.81,2.81c-1.55,0-2.82-1.26-2.82-2.81c0-1.55,1.27-2.82,2.82-2.82   C23.72,25.6,24.98,26.87,24.98,28.42z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubbleTea);
export default __webpack_public_path__ + "static/media/bubble-tea.019388ac9d6291d06d34b99eac4515fe.svg";
export { ForwardRef as ReactComponent };